import React from "react";

import { useAppApi } from "@/App";
import { MarketOrderTable } from "@components/MarketOrder";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function Orders({ developerId, header }) {
    const { apiData } = useAppApi(url_reverse("api:developer:orders", { developer_id: developerId }));

    if (!apiData) return;

    return (
        <ListingCard header={header}>
            <MarketOrderTable />
        </ListingCard>
    );
}
